import Vue from 'vue'
import vuetify from "./plugins/vuetify";
import App from './App.vue'
import Rollbar from 'rollbar';
import store from './store'

// Set the Rollbar instance in the Vue prototype
// before creating the first Vue instance.
// This ensures it is available in the same way for every
// instance in your app.
Vue.prototype.$rollbar = new Rollbar({
  accessToken: 'ce52b4d1cb2a4982977d4c3d20e5c4b4',
  captureUncaught: true,
  captureUnhandledRejections: true,
});

// If you have already set up a global error handler,
// just add `vm.$rollbar.error(err)` to the top of it.
// If not, this simple example will preserve the app’s existing
// behavior while also reporting uncaught errors to Rollbar.
Vue.config.errorHandler = (err, vm) => {
  vm.$rollbar.error(err);
  throw err; // rethrow
};

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App),
  vuetify
}).$mount('#app')
